import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showSuccess, showError } from "toast/toast";
import { useNavigate, useParams } from "react-router-dom";
import { useLoadScript } from "@react-google-maps/api";
import { addressLine1Validation, cityValidation, countryValidation, firstNameValidation, lastNameValidation, phoneValidation, stateValidation, zipcodeValidation } from "validationSchemas/common";
import AddressAutocomplete from "components/AddressAutocomplete";
import { getAuthCookie } from "../../utils/authCookies";

const libraries: Array<"places"> = ["places"];
const apiKey: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const SignageAddAddress = () => {
  const { agentId } = useParams<{ agentId: string }>();
  console.log("Agent ID:", agentId);
  const [preview, setPreview] = useState<string | null>(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0); // Track upload progress
  const navigate = useNavigate();
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const [loading, setLoading] = useState(true);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries,
  });

  const [address, setAddress] = useState("");

  const formik = useFormik({
    initialValues: {
      label_of_address: "",
      firstName: "",
      lastName: "",
      company: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      city: "",
      state: "",
      zipcode: "",
      phone: "",
      cityCode: "",
      stateCode: "",
      countryCode: "",
      latitude: 0,
      longitude: 0,
    },
    validationSchema: Yup.object({
      label_of_address: Yup.string().required("Label of address is required"),
      firstName: firstNameValidation,
      lastName: lastNameValidation,
      addressLine1: addressLine1Validation,
      city: cityValidation,
      state: stateValidation,
      zipcode: zipcodeValidation,
      country: countryValidation,
      phone: phoneValidation
    }),
    onSubmit: async (values) => {
      setFormSubmitting(true);

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/addresses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            user_id: userId,
            label: values.label_of_address,
            first_name: values.firstName,
            last_name: values.lastName,
            company: values.company,
            address_details: {
              addressLine1: values.addressLine1,
              addressLine2: values.addressLine2,
              label: values.label_of_address,
              city: values.city,
              state: values.state,
              zip: values.zipcode,
              country: values.country,
              phone: values.phone,
              cityCode: values.cityCode,
              stateCode: values.stateCode,
              countryCode: values.countryCode,
              latitude: values.latitude,
              longitude: values.longitude,
            },
          }),
        });

        if (!response.ok) {
          const error = await response.json();
          showError(error.message || error.error || "Failed to add address");
          throw new Error(error.message || "Failed to add address");
        }

        navigate("/signage/addresses");
        showSuccess("Address updated successfully!");
        // toast.success("Address added successfully!");
      } catch (error: any) {
        console.error(error);
        showError(`Error: ${error.message}`);
      } finally {
        setFormSubmitting(false);
        setUploadProgress(0);
      }
    }
  });


  return (
    <div className="content">
      {/* <div className="card2">
        <div className="card-body2"> */}
      <div className="col-md-12 d-flex justify-content-center">
        <div className=" col-md-9 ms-5 " style={{ marginTop: "0px" }}>
          <h3 className=" pt-1 fw-bold addheaders" >Add Address</h3>

          {/* form content here */}
        </div>
      </div>
      {/* <h2 className="d-flex justify-content-center">Add Address</h2> */}
      <div className="row ">
        <div className="col-md-12 d-flex justify-content-center">
          <div className="col-md-9">
            <div className="addheaders-content  card-bg-fill">
              <div className="p-2 px-4 mt-1">
                <form onSubmit={formik.handleSubmit}>
                  <div className=" row cust-margin-4">
                    <div>
                      <h5>Address Details</h5>
                      <hr className="lines" style={{ width: "110px" }} />
                    </div>
                    <div className="col-md-6 " >
                      <label className="form-label">
                        Label of address  <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="label_of_address"
                        name="label_of_address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.label_of_address}
                      />
                      {formik.touched.label_of_address && formik.errors.label_of_address ? (
                        <div className="text-danger">
                          {formik.errors.label_of_address}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                      />
                      {formik.touched.firstName && formik.errors.firstName ? (
                        <div className="text-danger">
                          {formik.errors.firstName}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                      />
                      {formik.touched.lastName && formik.errors.lastName ? (
                        <div className="text-danger">
                          {formik.errors.lastName}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Company
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="company"
                        name="company"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.company}
                      />
                      {formik.touched.company && formik.errors.company ? (
                        <div className="text-danger">
                          {formik.errors.company}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Phone number  <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        name="phone"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone}
                      />
                      {formik.touched.phone && formik.errors.phone ? (
                        <div className="text-danger">
                          {formik.errors.phone}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Address Line 1 <span className="text-danger">*</span>
                      </label>
                      <AddressAutocomplete
                        id="addressLine1"
                        name="addressLine1"
                        value={formik.values.addressLine1}
                        onChange={(v) => formik.setFieldValue("addressLine1", v)}
                        onSelect={(picked) => {
                          formik.setFieldValue("addressLine1", picked.addressLine1);
                          formik.setFieldValue("city", picked.city);
                          formik.setFieldValue("cityCode", picked.cityCode);
                          formik.setFieldValue("state", picked.state);
                          formik.setFieldValue("stateCode", picked.stateCode);
                          formik.setFieldValue("zipcode", picked.zipcode);
                          formik.setFieldValue("country", picked.country);
                          formik.setFieldValue("countryCode", picked.countryCode);
                          formik.setFieldValue("latitude", picked.latitude);
                          formik.setFieldValue("longitude", picked.longitude);
                        }}
                        className={`form-control ${formik.touched.addressLine1 && formik.errors.addressLine1 ? "is-invalid" : ""}`}
                        placeholder="Enter address"
                        error={formik.touched.addressLine1 && formik.errors.addressLine1 ? (formik.errors.addressLine1 as string) : undefined}
                      />
                      {formik.touched.addressLine1 && formik.errors.addressLine1 ? (
                        <div className="text-danger">
                          {formik.errors.addressLine1}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Address Line 2
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="addressLine2"
                        name="addressLine2"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.addressLine2}
                      />
                      {formik.touched.addressLine2 && formik.errors.addressLine2 ? (
                        <div className="invalid-feedback">
                          {formik.errors.addressLine2}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        City <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        name="city"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.city}
                      />
                      {formik.touched.city && formik.errors.city ? (
                        <div className="text-danger">
                          {formik.errors.city}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        State <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        name="state"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.state}
                      />
                      {formik.touched.state && formik.errors.state ? (
                        <div className="text-danger">
                          {formik.errors.state}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-6 ">
                      <label className="form-label">
                        Zip Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="zipcode"
                        name="zipcode"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.zipcode}
                      />
                      {formik.touched.zipcode && formik.errors.zipcode ? (
                        <div className="text-danger">
                          {formik.errors.zipcode}
                        </div>
                      ) : null}
                    </div> <div className="col-md-6 ">
                      <label className="form-label">
                        Country <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="country"
                        name="country"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.country}
                      />
                      {formik.touched.country && formik.errors.country ? (
                        <div className="text-danger">
                          {formik.errors.country}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3 rcust-margin-4">
                    <div className="col-md-12 d-flex justify-content-between">
                      <button
                        className="btn btn-outline-secondary br-8 backbutton"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>

                      <button className="btn btn-primary submit-btn" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                  {/* <div className="rcust-margin-4 justify-content-end mt-3 mb-4 row text-end">
                    <div className="col-md-12">
                      <button className="btn btn-primary submit-btn " type="submit">
                        Submit
                      </button>
                    </div>
                  </div> */}

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    //   </div>
    // </div>
  );
};

export default SignageAddAddress;







//  <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="label_of_address" className="form-label">
//                           Label of Address <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.label_of_address && formik.errors.label_of_address ? "is-invalid" : ""
//                             }`}
//                           id="label_of_address"
//                           name="label_of_address"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.label_of_address}
//                           style={{ borderColor: '#c6dce5' }}
//                         />
//                         {formik.touched.label_of_address && formik.errors.label_of_address && (
//                           <div className="text-danger">{formik.errors.label_of_address}</div>
//                         )}
//                       </div>
//                     </div>


//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="firstName" className="form-label">
//                           First Name <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.firstName && formik.errors.firstName ? "is-invalid" : ""
//                             }`}
//                           id="firstName"
//                           name="firstName"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.firstName}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.firstName && formik.errors.firstName && (
//                           <div className="text-danger">{formik.errors.firstName}</div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="lastName" className="form-label">
//                           Last Name <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.lastName && formik.errors.lastName ? "is-invalid" : ""
//                             }`}
//                           id="lastName"
//                           name="lastName"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.lastName}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.lastName && formik.errors.lastName && (
//                           <div className="text-danger">{formik.errors.lastName}</div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="company" className="form-label">
//                           Company <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.company && formik.errors.company ? "is-invalid" : ""
//                             }`}
//                           id="company"
//                           name="company"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.company}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.company && formik.errors.company && (
//                           <div className="text-danger">{formik.errors.company}</div>
//                         )}
//                       </div>
//                     </div>
//                                         <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="country" className="form-label">
//                           Country <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.country && formik.errors.country ? "is-invalid" : ""
//                             }`}
//                           id="country"
//                           name="country"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.country}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.country && formik.errors.country && (
//                           <div className="text-danger">{formik.errors.country}</div>
//                         )}
//                       </div>
//                     </div>


//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="phone" className="form-label">
//                           Phone Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.phone && formik.errors.phone ? "is-invalid" : ""
//                             }`}
//                           id="phone"
//                           name="phone"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.phone}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.phone && formik.errors.phone && (
//                           <div className="text-danger">{formik.errors.phone}</div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="addressLine1" className="form-label">
//                           Address Line 1  <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.addressLine1 && formik.errors.addressLine1 ? "is-invalid" : ""
//                             }`}
//                           id="addressLine1"
//                           name="addressLine1"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.addressLine1}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.addressLine1 && formik.errors.addressLine1 && (
//                           <div className="text-danger">{formik.errors.addressLine1}</div>
//                         )}
//                       </div>
//                     </div>
//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="addressLine2" className="form-label">
//                           Address Line 2 <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.addressLine2 && formik.errors.addressLine2 ? "is-invalid" : ""
//                             }`}
//                           id="addressLine2"
//                           name="addressLine2"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.addressLine2}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.addressLine2 && formik.errors.addressLine2 && (
//                           <div className="text-danger">{formik.errors.addressLine2}</div>
//                         )}
//                       </div>
//                     </div>
//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="city" className="form-label">
//                           City <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.city && formik.errors.city ? "is-invalid" : ""
//                             }`}
//                           id="city"
//                           name="city"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.city}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.city && formik.errors.city && (
//                           <div className="text-danger">{formik.errors.city}</div>
//                         )}
//                       </div>
//                     </div>
//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="state" className="form-label">
//                           State<span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.state && formik.errors.state ? "is-invalid" : ""
//                             }`}
//                           id="state"
//                           name="state"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.state}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.state && formik.errors.state && (
//                           <div className="text-danger">{formik.errors.state}</div>
//                         )}
//                       </div>
//                     </div>


//                     <div className="col-md-4 mb-3 position-relative custom-floating-group">
//                       <div className="form-group">
//                         <label htmlFor="zipcode" className="form-label">
//                           Zip Code  <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           className={`form-control custom-input border-0 border-bottom rounded-0 shadow-none ${formik.touched.zipcode && formik.errors.zipcode ? "is-invalid" : ""
//                             }`}
//                           id="zipcode"
//                           name="zipcode"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values.zipcode}
//                           style={{ borderColor: '#c6dce5' }} // Light bottom border
//                         />
//                         {formik.touched.zipcode && formik.errors.zipcode && (
//                           <div className="text-danger">{formik.errors.zipcode}</div>
//                         )}
//                       </div>
//                     </div>